import { Helmet } from "react-helmet";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import Pagebanner from "../../layout/Banner";
import ContactForm from "../../Components/HomeSections/ContactForm";

const ContactUS = () => {
  const brandGold = "#E3B66B";
  const darkGreen = "#0A1D1B";
  return (
    <>
      <Helmet>
        <title>Contact Us - Rai & Associates Chambers</title>
        <meta
          name="description"
          content="Get in touch with Rai & Associates Chambers. Fill out our contact form to consult with our expert lawyers, ask questions, or request legal services."
        />
        <meta
          name="keywords"
          content="Contact Rai & Associates, Legal Consultation, Law Firm Contact, Lawyer Inquiry, Legal Services Contact"
        />
        <noscript>
          Please enable JavaScript to view this website properly.
        </noscript>
      </Helmet>

      <Header />
      <Pagebanner title="Contact Us" />
      <ContactForm />

      {/* Map Section */}
      <section className={`bg-[${darkGreen}] py-12 px-6 md:px-12`}>
        <div
          className="max-w-7xl mx-auto rounded-lg overflow-hidden shadow-lg border-2"
          style={{ borderColor: brandGold }}
        >
          <iframe
            title="Rai & Associates Chambers Location"
            src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d448182.7274481491!2d77.364617!3d28.646914000000002!3m2!1i1024!2i768!4f13.1!2m1!1sOffice%20No-%2012%2C%20Plot%20No-%203%2C%20Niti%20Khand-2%2C%20Ghaziabad%2C%20Uttar%20Pradesh%20201014!5e0!3m2!1sen!2sus!4v1782191579644!5m2!1sen!2sus"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ContactUS;


